import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Form, Label, Spinner } from "reactstrap";
import { useFieldArray, useForm } from "react-hook-form";
import MyInput from "../../MyComp/UI/form/MyInput";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import MyDate from "../../MyComp/UI/form/MyDate";
import moment from "moment";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import MyGender from "../../MyComp/UI/form/MyGender";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import Required from "../../MyComp/UI/form/Required";
import MySelect from "../../MyComp/UI/form/MySelect";
import axios from "axios";
import MyCreateSelect from "../../MyComp/UI/form/MyCreateSelect";
import {
  departmentDDAPI,
  districtDDAPI,
  getsubqualificationDDAPI,
  qualificationDDAPI,
  specializationDDAPI,
  stateDDAPI,
} from "../../api/dropdown";
import { toast } from "react-toastify";
import {
  addDoctorAPI,
  getDoctorDetailAPI,
  getZipDetailsAPI,
  refferalDetailAPI,
  reviewDoctorAPI,
  updateDoctorAPI,
} from "../../api/doctor";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL_IMG, slotDuration } from "../../assets/constants";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import useLogout from "../../hooks/useLogout";
import Nouislider from "nouislider-react";
import MyCheck from "../../MyComp/UI/form/MyCheck";

const DoctorRegistration = () => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      debounceLoading: false,
      credit: 0,
      qualificationList: [],
      sub_qualificationList: [],
      stateList: [],
      cityList: [],
      specializationDD: [],
      departmentDD: [],

      profile_image: null,
      profile_img: null,

      pan_image: null,
      pan_img: null,

      cert_image: null,
      cert_img: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,
      qualifications: [
        {
          degree: "",
          qualification: null,
          qualification_id: null,
          sub_qualifications: null,
          passing_year: "",
          certificate_no: "",
          university: "",
          certificate: null,
          certificate_url: null,
          referral_code: null,
        },
      ],
      experiences: [
        {
          organization: "",
          from_date: null,
          to_date: null,
          department_id: "",
          is_current: false,
        },
      ],
      objectionKeys: [],
      approvedKeys: [],
      actionType: null,
      exp: false,
    },
  });
  //   useEffect(() => {
  //   if (watch(`experiences.${index}.isCurrent`)) {
  //     setValue(`experiences.${index}.end_time`, null);
  //   }
  // }, [watch(`experiences.${index}.isCurrent`)]);

  const logout = useLogout();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "qualifications",
  });
  const {
    fields: experienceFields,
    append: appendExperience,
    remove: removeExperience,
  } = useFieldArray({
    control,
    name: "experiences",
  });

  function parseTimeToDate(timeString) {
    const date = new Date();

    // Check if timeString includes AM/PM
    if (/AM|PM/i.test(timeString)) {
      const [time, modifier] = timeString.split(/ (AM|PM)/i);
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier.toUpperCase() === "PM" && hours < 12) {
        hours += 12;
      }
      if (modifier.toUpperCase() === "AM" && hours === 12) {
        hours = 0;
      }

      date.setHours(hours);
      date.setMinutes(minutes);
    } else {
      // Assume 24-hour format
      const [hours, minutes] = timeString.split(":").map(Number);
      date.setHours(hours);
      date.setMinutes(minutes);
    }

    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }
  const navigate = useNavigate();
  const location = useLocation();

  const [mode, setMode] = useState(location?.state?.mode ? location?.state?.mode : "Add");
  const [imageOpen, setImageOpen] = useState(false);
  const isLoading = watch("isLoading");
  const debounceLoading = watch("debounceLoading");
  const DEBOUNCE_DELAY = 1000; // milliseconds
  const referralCode = watch("referral_code");
  const [debouncedCode, setDebouncedCode] = useState(referralCode);
  const [referralDetails, setReferralDetails] = useState(null);

  function calculateTotalExperience(experiences) {
    let totalMonths = 0;

    experiences.forEach((exp) => {
      const fromDate = moment(exp.from_date);
      // If is_current is true, use today's date as the end
      const toDate = exp.is_current ? moment() : moment(exp.to_date);

      if (fromDate.isValid() && toDate.isValid() && toDate.isAfter(fromDate)) {
        const diffMonths = toDate.diff(fromDate, "months");
        totalMonths += diffMonths;
      }
    });

    const yearss = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;

    return { yearss, months };
  }

  const experiences = watch("experiences"); // from react-hook-form
  console.log("log--->", watch("experiences"), mode, experiences);

  const { yearss, months } = calculateTotalExperience(experiences);






  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedCode(referralCode);
    }, DEBOUNCE_DELAY);

    return () => {
      clearTimeout(handler);
    };
  }, [referralCode]);





  // useEffect(() => {

  //   if (debouncedCode && debouncedCode.length >= 2) {
  //     // Replace with your actual API call
  //     setValue("debounceLoading", true);
  //     console.log("hit api with code", debouncedCode);
  //     setTimeout(() => {
  //       setValue("debounceLoading", false);
  //       setReferralDetails({
  //         name: "Test",
  //       });
  //     }, 1000);
  //   }
  // }, [debouncedCode]);
  useEffect(() => {
    if (debouncedCode && debouncedCode.length >= 2) {
      // Replace with your actual API call
      setValue("debounceLoading", true);
      const bodyData = {
        referral_code: debouncedCode,
      };
      refferalDetailAPI(bodyData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.clearWaitingQueue();
            setValue("debounceLoading", false);
            // setReferralDetails({
            //   name: res.data.data.name || "",
            // });
            setReferralDetails(res.data.data);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            setValue("debounceLoading", false);
            setReferralDetails(res.data.data);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  }, [debouncedCode]);

  console.log("qualifications", watch("qualifications[0].passing_year"));

  const getDrDetails = (body) => {
    getDoctorDetailAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("doctorDetail", res.data.data);
          const doctor = res.data.data;
          setValue("isLoading", false);
          setValue("bio", doctor?.about);
          setValue("exp", doctor?.is_experince);
          setValue("credit", doctor?.credit || 0);
          if (mode == "Approval") {
            setValue("objectionKeys", doctor.keys);
          }
          setValue("referral_code", doctor?.refferal_code || null);
          setValue("name", doctor?.name || null);
          setValue("email", doctor?.email || null);
          setValue("mobile", doctor?.mobile || null);
          setValue("alt_mobile", doctor?.phone_consult || null);
          setValue("experience", doctor?.experience || null);
          setValue("appointment_fees", doctor?.appointment_fees || null);
          setValue("remark", doctor?.remark || null);
          setValue("registration", doctor?.registration_no || null);
          const gen = [
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
            { value: "other", label: "Other" },
          ].find((item) => item.value == doctor?.gender);
          setValue("gender", gen || null);
          setValue("state", doctor?.state || null);
          setValue("city", doctor?.city || null);
          setValue("pin_code", doctor?.pin_code || null);
          setValue("specialization", doctor?.specialization || null);

          if (doctor?.known_language) {
            const tagArray = doctor?.known_language?.map((tag) => {
              const trimmed = tag.trim();
              return {
                label: trimmed,
                value: trimmed,
              };
            });

            setValue("known_language", tagArray);
          }
          setValue("address", doctor?.address || null);

          // setValue("disease", doctor?.disease || null);
          // setValue("treatment", doctor?.treatment || null);
          setValue(
            "aadhaar_f_image",
            doctor?.addhar_front_image == null ? null : BASE_URL_IMG + doctor?.addhar_front_image,
          );
          setValue(
            "aadhaar_b_image",
            doctor?.addhar_back_image == null ? null : BASE_URL_IMG + doctor?.addhar_back_image,
          );
          setValue(
            "profile_image",
            doctor?.profile_image == null ? null : BASE_URL_IMG + doctor?.profile_image || null,
          );
          setValue("pan_image", doctor?.pan_no == null ? null : BASE_URL_IMG + doctor?.pan_no || null);
          setValue("cert_image", doctor?.cert_image == null ? null : BASE_URL_IMG + doctor?.cert_image || null);
          setValue("dob", new Date(doctor?.dob || null));
          setValue("year_of_completion", new Date(doctor?.year_of_completion || null));
          console.log("dct", doctor);
          doctor?.qualification_data?.forEach((item, index) => {
            // Ensure enough fields exist
            if (index > 0) {
              append({
                // qualification: null,
                // sub_qualifications: null,
                // degree: "",
                passing_year: "",
                certificate_no: "",
                university: "",
                certificate: null,
                certificate_url: null,
                referral_code: null,
              });
            }
            if (item.passing_year) {
              const year = new Date(item.passing_year).getFullYear();

              setValue(`qualifications.${index}.passing_year`, new Date(year, 0, 1));
            }
            getSubqualificationList(item?.qualification_id, index);
            setValue(
              `qualifications[${index}].qualification`,
              item.qualification_id
                ? {
                  value: item.qualification_id,
                  label: item.degree,
                }
                : null,
            );

            setValue(
              `qualifications[${index}].sub_qualifications`,
              item.sub_qualification_id
                ? {
                  value: item.sub_qualification_id,
                  label: item.stream,
                }
                : null,
            );
            // setValue(`qualifications[${index}].degree`, item.degree);
            // setValue(`qualifications[${index}].passing_year`,item?.passing_year? new Date(item.passing_year):null);
            // trigger(`qualifications[${index}].passing_year`)
            setValue(`qualifications[${index}].university`, item.university);
            // setValue(`qualifications[${index}].certificate_no`, item.certificate_no);
            // setValue(`qualifications[${index}].certificate`, BASE_URL_IMG + item.certificate || "");
            // setValue(`qualifications[${index}].certificate_url`, BASE_URL_IMG + item.certificate || "");
            // if (item.certificate_type) {
            //   setValue(`qualifications[${index}].certificate_type`, item.certificate_type);
            // }
          });

          doctor?.experience_data?.forEach((item, index) => {
            if (index > 0) {
              appendExperience({
                organization: "",
                from_date: null,
                to_date: null,
                department: null,
                is_current: false,
              });
            }
            console.log("ex,,,,,,,", item);

            setValue(`experiences.${index}.organization`, item.organization);

            setValue(`experiences.${index}.from_date`, item.from_date ? new Date(item.from_date) : null);

            setValue(`experiences.${index}.to_date`, item.to_date ? new Date(item.to_date) : null);

            setValue(
              `experiences.${index}.department_id`,
              item.department ? { value: item.department.value, label: item.department.label } : null,
            );

            setValue(`experiences.${index}.is_current`, true);
            trigger("experiences");
          });

          const sTime24 = doctor?.from_date; // e.g., "17:30"
          const parsedTime = sTime24 ? parseTimeToDate(sTime24) : null;
          const eTime24 = doctor?.to_date; // e.g., "17:30"
          const parsedETime = eTime24 ? parseTimeToDate(eTime24) : null;
          setValue("from_date", doctor?.parsedTime ? new Date(parsedTime) : null);
          setValue("to_date", doctor?.parsedETime ? new Date(parsedETime) : null);
          setValue("is_Current", doctor?.is_current ? true : false);
          // setValue("department", doctor?.department ? doctor?.department.label : null);

          const avail = [
            { value: "Monthly", label: "Monthly" },
            { value: "Weekdays", label: "Weekdays" },
            { value: "Weekends", label: "Weekends" },
          ].find((item) => item.value == doctor?.availability);
          setValue("show_availability", avail || null);

          setValue("online_consultation_fees", doctor?.online_consultation_fees || null);
          setValue("duration", doctor?.duration || null);
          setValue("appointment_fees", doctor?.appointment_fees);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("doctorDetail", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getqualificationList = () => {
    qualificationDDAPI()
      .then((res) => {
        if (res.data.status === true) {
          console.log(res.data, "res.data");

          setValue("qualificationList", res?.data?.data);
        } else if (res.data.status === false) {
          setValue("qualificationList", []);
          toast.error(res.data.message);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => toast.error(err.message));
  };

  const getSubqualificationList = async (qualificationId, index) => {
    try {
      console.log(qualificationId, "qualificationId");
      const data = {
        id: qualificationId?.value || qualificationId,
      };
      const res = await getsubqualificationDDAPI(data);
      if (res?.data?.status === true) {
        setValue(`sub_qualificationMap.${index}`, res.data.data);
      } else if (res?.data?.status === false) {
        setValue(`sub_qualificationMap.${index}`, []);
        setValue(`qualifications.${index}.sub_qualifications`, "");
        // toast.error(res.data.message);
      } else if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        logout();
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const qualifications = watch("qualifications") || [];

  const handleSpecializationFetch = (qualifications) => {
    const qualificationIds = [];
    const subQualificationIds = [];

    console.log("00000", qualifications)




    qualifications.forEach((item) => {
      if (item?.qualification?.value) {
        qualificationIds.push(item.qualification.value);
      }
      if (item?.sub_qualifications?.value) {
        subQualificationIds.push(item.sub_qualifications.value);
      }
    });

    // If both arrays are empty, reset dropdown
    if (!qualificationIds.length && !subQualificationIds.length) {
      setValue("specializationDD", []);
      return;
    }

    const payload = {
      qualification_id: qualificationIds,
      sub_qualifiaction_id: subQualificationIds,
    };
    console.log("qual", qualifications);
    // return
    console.log("Specialization Payload 👉", payload);
    getSpecializationDD(payload);
  };

  useEffect(() => {
    if (!qualifications.length) return;

    // Check if at least one qualification or sub-qualification exists
    const hasAnyValue = qualifications.some((q) => q?.qualification?.value || q?.sub_qualifications?.value);

    if (!hasAnyValue) return;

    handleSpecializationFetch(qualifications);
  }, [
    // Trigger if any qualification or sub-qualification changes
    qualifications.map((q) => q?.qualification?.value).join(","),
    qualifications.map((q) => q?.sub_qualifications?.value).join(","),
  ]);

  useEffect(() => {
    if (mode == "Edit" || mode == "Approval") {
      const body = {
        id: location?.state?.data?.id,
      };
      getDrDetails(body);
    }
    // getState();
    // getSpecialization();
    getDepartment();
    getqualificationList();
  }, []);

  const getSpecializationDD = (data) => {
    console.log(data, "data");
    // return
    specializationDDAPI(data)
      .then((res) => {
        if (res.data.status === true) {
          setValue("specializationDD", res.data.data);
        } else if (res.data.status === false) {
          setValue("specializationDD", []);
          // toast.error(res.data.message);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => toast.error(err.message));
  };

  const getSpecialization = () => {
    specializationDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("specializationDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("specializationDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  // const getDisease = () => {
  //   diseaseDDAPI()
  //     .then((res) => {
  //       //const status = decrypt(res.data.status);
  //       if (res.data.status === true) {
  //         toast.clearWaitingQueue();
  //         setValue("diseaseDD", res.data.data);
  //         setValue("isLoading", false);
  //       } else if (res.data.status === false) {
  //         setValue("isLoading", false);
  //         setValue("diseaseDD", []);
  //         toast.error(res.data.message);
  //         toast.clearWaitingQueue();
  //       } else if (res.data.status === "expired") {
  //         setValue("isLoading", false);
  //         toast.error(res.data.message);
  //         toast.clearWaitingQueue();
  //         logout();
  //       }
  //     })
  //     .catch((err) => {
  //       setValue("isLoading", false);
  //       toast.error(err?.response?.data?.message);
  //     });
  // };
  // const getreatment = () => {
  //   treatmentDDAPI()
  //     .then((res) => {
  //       //const status = decrypt(res.data.status);
  //       if (res.data.status === true) {
  //         toast.clearWaitingQueue();
  //         setValue("treatmentDD", res.data.data);
  //         setValue("isLoading", false);
  //       } else if (res.data.status === false) {
  //         setValue("isLoading", false);
  //         setValue("treatmentDD", []);
  //         toast.error(res.data.message);
  //         toast.clearWaitingQueue();
  //       } else if (res.data.status === "expired") {
  //         setValue("isLoading", false);
  //         toast.error(res.data.message);
  //         toast.clearWaitingQueue();
  //         logout();
  //       }
  //     })
  //     .catch((err) => {
  //       setValue("isLoading", false);
  //       toast.error(err?.response?.data?.message);
  //     });
  // };

  const getDepartment = () => {
    departmentDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("departmentDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("departmentDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    setValue("selectedRow", location?.state?.data);
    // if (watch("state") != null) {
    //   const body = {
    //     state_id: watch("state")?.value,
    //   };
    //   console.log("satte", watch("state"));
    //   getDistrict(body);
    // }
  }, [watch("state")]);
  const getState = () => {
    stateDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("stateList", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("brandsDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getDistrict = (body) => {
    districtDDAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("cityList", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("cityList", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const formatDOB = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const onFormSubmit = (data) => {
    console.log(data, "data");
    const formData = new FormData();
    if (mode == "Add") {
      formData.append("referral_code", watch("referral_code") || 0);
      formData.append("refferedBy", referralDetails?.id || 0);
    }
    formData.append("name", watch("name") || null);
    formData.append("email", watch("email") || null);
    formData.append("mobile", watch("mobile") || null);
    formData.append("credit", watch("credit") || 0);
    formData.append("alt_mobile", watch("alt_mobile") || null);
    formData.append("dob", watch("dob") || null);
    formData.append("year_of_completion", watch("year_of_completion") || null);
    formData.append("gender", watch("gender")?.value || null);
    // formData.append("experience", yearss + "." + months || 0);
    formData.append("experience", qyears + "." + qmonths || 0);
    formData.append("registration", watch("registration") || null);
    formData.append("bio", watch("bio") || null);
    // formData.append("state", watch("state").value);
    // formData.append("city", watch("city").value);
    // formData.append("pin_code", watch("pin_code") || null);
    // formData.append("department", watch("department").value);
    formData.append("from_date", moment(watch("from_date")).format("hh:mm A") || null);
    formData.append("to_date", moment(watch("to_date")).format("hh:mm A") || null);

    // formData.append("availability", watch("show_availability")?.value || null);
    formData.append("online_consultation_fees", watch("online_consultation_fees") || null);
    formData.append("duration", watch("duration") || null);
    // formData.append("appointment_fees", watch("appointment_fees") || null);

    const metaImg = watch("profile_img");
    if (metaImg instanceof File) {
      formData.append("profile_img", metaImg || null);
    } else if (typeof metaImg === "string") {
      formData.append("profile_img", metaImg || null);
    }
    const panImg = watch("pan_img");
    if (panImg instanceof File) {
      formData.append("pan_img", panImg || null);
    } else if (typeof panImg === "string") {
      formData.append("pan_img", panImg || null);
    }
    const aadhaarFImg = watch("aadhaar_f_img");
    if (aadhaarFImg instanceof File) {
      formData.append("aadhaar_f_img", aadhaarFImg || null);
    } else if (typeof aadhaarFImg === "string") {
      formData.append("aadhaar_f_img", aadhaarFImg || null);
    }

    const aadhaarBImg = watch("aadhaar_b_img");
    if (aadhaarBImg instanceof File) {
      formData.append("aadhaar_b_img", aadhaarBImg || null);
    } else if (typeof aadhaarBImg === "string") {
      formData.append("aadhaar_b_img", aadhaarBImg || null);
    }
    const certImg = watch("cert_img");
    if (certImg instanceof File) {
      formData.append("cert_img", certImg || null);
    } else if (typeof certImg === "string") {
      formData.append("cert_img", certImg || null);
    }
    formData.append(
      "known_language",
      watch("known_language")?.map((item) => item.value),
    );
    if (watch("specialization")?.length > 0) {
      formData.append(
        "specialization",
        watch("specialization")?.map((item) => item.value),
      );
    } else {
      formData.append("specialization", watch("specialization"));
    }

    console.log("asda", watch("specialization"));
    // return
    // if (watch("department")?.length > 0) {
    //   formData.append(
    //     "department",
    //     watch("department")?.map((item) => item.value)
    //   );

    // } else {
    //   formData.append("department", watch("department").value);
    // }

    // formData.append("address", watch("address"));

    data?.qualifications?.forEach((item, index) => {
      formData.append(`qualifications[${index}][qualification_id]`, item?.qualification?.value ?? "");
      formData.append(`qualifications[${index}][degree]`, item?.qualification?.label ?? "");
      if (item?.sub_qualifications?.value) {
        formData.append(`qualifications[${index}][sub_qualification_id]`, item?.sub_qualifications?.value);
      }

      formData.append(`qualifications[${index}][stream]`, item?.sub_qualifications?.label ?? "");
      // formData.append(`qualifications[${index}].degree`, item.degree);
      formData.append(`qualifications[${index}][passing_year]`, item.passing_year);
      formData.append(`qualifications[${index}][university]`, item.university);
      // formData.append(`qualifications[${index}].certificate_no`, item.certificate_no);
      // formData.append(`qualifications[${index}].certificate`, item.certificate || "");
      // if (item.certificate_type) {
      //   formData.append(`qualifications[${index}].certificate_type`, item.certificate_type);
      // }
    });
    data?.experiences?.forEach((item, index) => {
      formData.append(`experiences[${index}].organization`, item.organization);
      formData.append(`experiences[${index}].department_id`, item.department_id.value);
      formData.append(`experiences[${index}].from_date`, formatDOB(item.from_date));
      formData.append(`experiences[${index}].to_date`, !item.is_current ? formatDOB(item?.to_date) : null);
      formData.append(`experiences[${index}].is_current`, item.is_current);
      // if (item.certificate_type) {
      //   formData.append(`qualifications[${index}].certificate_type`, item.certificate_type);
      // }
    });
    console.log("data for doctor registration", data);
    // console.log(mode, "mode");

    // return

    if (mode == "Edit") {
      console.log(formData, "formData");
      console.log(mode, "mode");
      formData.append("id", watch("selectedRow")?.id);
    }
    if (mode == "Add") {
      addDoctorAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setValue("isLoading", false);
            navigate("/doctor/list");
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateDoctorAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setValue("isLoading", false);
            navigate("/doctor/list");
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Approval" && watch("actionType") == "change_requested") {
      const body = {
        remark: watch("remark") || "",
        keys: watch("objectionKeys")?.map((item) => item) || [],
        doctorId: watch("selectedRow")?.id || "",
        actionType: "change_requested",
      };
      reviewDoctorAPI(body).then((res) => {
        if (res.data.status === true) {
          navigate("/doctor/list");
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
    if (mode == "Approval" && watch("actionType") == "approve") {
      const body = {
        remark: watch("remark") || "",
        doctorId: watch("selectedRow")?.id || "",
        actionType: "approved",
      };
      reviewDoctorAPI(body).then((res) => {
        if (res.data.status === true) {
          navigate("/doctor/list");
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
  };
  const diseaseCount = Array.isArray(watch("disease")) ? watch("disease").length : 0;

  // const years = [
  //   { value: "2026", label: "2026" },
  //   { value: "2025", label: "2025" },
  //   { value: "2024", label: "2024" },
  //   { value: "2023", label: "2023" },
  //   { value: "2022", label: "2022" },
  //   { value: "2021", label: "2021" },
  // ];
  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 60 }, (_, index) => {
    const year = currentYear - index;
    return {
      value: String(year),
      label: String(year),
    };
  });
  useEffect(() => {
    if (watch("pin_code") && watch("pin_code").toString().length === 6) {
      const body = {
        pin_code: watch("pin_code"),
      };
      getZipDetails(body);
    }
  }, [watch("pin_code")]);

  const getZipDetails = (body) => {
    getZipDetailsAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const responseData = res.data.data;
          console.log("zip details", responseData);
          setValue("city", responseData.district_name);
          setValue("state", responseData.state_name);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  function formatExperience(years, months) {
    if (!years && !months) return "0 Months";

    let text = "";

    if (years) text += `${years} Year${years > 1 ? "s" : ""} `;
    if (months) text += `${months} Month${months > 1 ? "s" : ""}`;

    return text.trim();
  }

  const getFilteredQualificationOptions = (currentIndex) => {
    const selectedValues = qualifications
      ?.map((q, i) => (i !== currentIndex ? q?.qualification?.value : null))
      .filter(Boolean);

    return watch("qualificationList")?.filter(
      opt => !selectedValues.includes(opt.value)
    );
  };

  const isQualificationSelected = (value) => {
    const list = watch("qualifications") || [];
    return list.some(q => q?.qualification?.value == value);
  };

  function calculateQualificationExperience(qualifications) {
    if (!qualifications || qualifications.length === 0) {
      return { qyears: 0, qmonths: 0 };
    }

    const dates = qualifications
      .map((q) => moment(q?.passing_year))
      .filter((d) => d.isValid());

    if (!dates.length) return { qyears: 0, qmonths: 0 };

    const firstPassingYear = moment.min(dates);
    const now = moment();

    const totalMonths = now.diff(firstPassingYear, "months");

    const qyears = Math.floor(totalMonths / 12);
    const qmonths = totalMonths % 12;

    return { qyears, qmonths };
  }
  const qualificationss = watch("qualifications");

  const { qyears, qmonths } = calculateQualificationExperience(qualificationss);


  return (
    <>
      <Head title={"Registration | Doctor"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Doctor Registration"}
              </BlockTitle>
            </BlockHeadContent>
            {location?.state == null ? null : (
              <BlockHeadContent>
                <div className="">
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      navigate("/doctor/list");
                    }}
                  >
                    <Icon name={"arrow-left"} />
                  </Button>
                </div>
              </BlockHeadContent>
            )}
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <div className="d-flex gap-5 py-3 mb-3">
                  {" "}
                  <h5>{"Basic Details"}</h5>
                </div>
                {mode == "Add" && (
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Referral Code"}
                      name={"referral_code"}
                      placeholder={"Enter referral code"}
                      min={2}
                      max={50}
                    />
                    {debounceLoading ? (
                      <p style={{ marginTop: "8px" }}>
                        <Spinner size={"sm"} color="primary" /> {" Fetching referral details…"}
                      </p>
                    ) : (
                      <>
                        {referralDetails && (
                          <div style={{ marginTop: "8px", color: "green" }}>
                            {" "}
                            Referral found: {referralDetails.name || "none"}
                          </div>
                        )}
                      </>
                    )}
                  </Col>
                )}
                <Col md="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Name"}
                    name={"name"}
                    placeholder={"Enter name"}
                    required
                    min={2}
                    max={50}
                  />
                </Col>
                <Col md="3" className={``}>
                  <MyEmail
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Email"}
                    name={"email"}
                    placeholder={"Enter email"}
                    required
                  />
                </Col>
                <Col md="3" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Mobile"}
                    name={"mobile"}
                    placeholder={"Enter mobile"}
                    required
                  />
                </Col>
                {/* <Col md="2" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Alternate Mobile1"}
                    name={"alt_mobile"}
                    placeholder={"Enter alternate mobile"}
                    // required
                  />
                </Col> */}
                <Col md="3" className={``}>
                  <MyDate
                    control={control}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Date of Birth"}
                    name={"dob"}
                    placeholder={"Enter date of birth"}
                    required
                    max={moment().subtract(20, "years").toDate()}
                    min={moment().subtract(90, "years").toDate()}
                  />
                </Col>
                <Col md={3}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Gender"}
                    name={"gender"}
                    placeholder={"Select gender"}
                    required
                    options={[
                      { value: "male", label: "Male" },
                      { value: "female", label: "Female" },
                      { value: "other", label: "Other" },
                    ]}
                  />
                </Col>
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Experience"}
                    name={"experience"}
                    placeholder={"experience"}
                    required
                    min={1}
                    max={2}
                  />
                </Col> */}
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Medical Council Registration No"}
                    name={"registration"}
                    placeholder={"Enter registration number"}
                    required
                    min={5}
                    max={15}
                  />
                </Col>
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}> */}
                {/* <MyDate
                 control={control}
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Year of Completion"}
                    name={"year_of_completion"}
                    placeholder={"Enter date of completion"}
                    required
                    max={new Date()}
                    min={moment().subtract(90, "years").toDate()}
                  />
                </Col>
                <Col md={2}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"State"}
                    name={"state"}
                    placeholder={"Select state"}
                    required
                    options={watch("stateList")}
                  />
                </Col>
                <Col md={2}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"City"}
                    name={"city"}
                    placeholder={"Select city"}
                    required
                    options={watch("cityList")}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Pin Code"}
                    name={"pin_code"}
                    placeholder={"Enter pin code"}
                    required
                    min={6}
                    max={6}
                  />
                </Col>
                */}
                <Col md="3" className={``}>
                  <MyCreateSelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Languages Known"}
                    name={"known_language"}
                    placeholder={"specify known languages"}
                    required
                    multi
                  />
                </Col>

                {/* <Col md="2">
                  <Label className="my-3">Select Fees</Label>

        

                  <Nouislider
                    className="form-range-slider small-pointer h-5 w-5  "
                    accessibility
                    tooltips={[{ to: (value) => Math.round(value) }, { to: (value) => Math.round(value) }]}
                    connect={true}
                    margin={30}
                    start={[50, 2000]}
                    range={{
                      min: 50,
                      max: 2000,
                    }}
                    onChange={(vals) => {
                      const valueArray = vals.map((v) => Math.round(Number(v)));

                      console.log(valueArray, "rounded values");

                      setValue("online_consultation_fees", valueArray, {
                        shouldValidate: true,
                        shouldDirty: true,
                        shouldTouch: true,
                      });
                    }}
                  />
                              <div className="d-flex justify-content-between mb-2">
    <span>₹{watch("online_consultation_fees")?.[0] ?? 50}</span>
    <span>₹{watch("online_consultation_fees")?.[1] ?? 2000}</span>
  </div>
                  <style>
                    {`
  .small-pointer .noUi-handle {
    width: 18px !important;
    height: 18px !important;
    top: 5px !important;
    // box-shadow: none !important;
  }
  .small-pointer .noUi-handle:before,
  .small-pointer .noUi-handle:after {
    display: none !important;
  }
`}
                  </style>

                  <input
                    type="hidden"
                    {...register("online_consultation_fees", {
                      required: "Please select online consultation fees",
                      validate: (v) => (Array.isArray(v) && v.length === 2 ? true : "Please move the slider"),
                    })}
                  />

                  {errors?.online_consultation_fees && (
                    <p className="invalid">{errors.online_consultation_fees.message}</p>
                  )}
                </Col> */}

                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="profile_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Profile Image"}
                    errors={errors}
                    register={register}
                    image={"profile_img"}
                    image_url={"profile_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="aadhaar_f_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Front Image"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_f_img"}
                    image_url={"aadhaar_f_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    // required
                    validateDoc
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="aadhaar_b_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Back Image"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_b_img"}
                    image_url={"aadhaar_b_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    // required
                    validateDoc
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="pan_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"PAN Image"}
                    errors={errors}
                    register={register}
                    image={"pan_img"}
                    image_url={"pan_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    // required
                    validateDoc
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    id="cert_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Certificate Image"}
                    errors={errors}
                    register={register}
                    image={"cert_img"}
                    image_url={"cert_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                  />
                </Col>

                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Disease"}
                    name={"disease"}
                    placeholder={"Select disease"}
                    required
                    options={watch("diseaseDD")}
                    multi
                  />
                </Col> */}
                <Col xs="12" sm="6" md="4" lg="6" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Bio/Description"}
                    name={"bio"}
                    placeholder={"Tell us something about you"}
                    min={5}
                    max={10000}
                    cols={2}
                    row={2}
                  />
                </Col>
              </Row>
              <Row>
                {/* <Col md="6" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Address"}
                    name={"address"}
                    placeholder={"Enter address"}
                    required
                    min={5}
                    max={200}
                    cols={2}
                    row={2}
                  />
                </Col> */}
              </Row>
              <Row>
                <div className="my-div  ">
                  <BlockTitle tag="h6">{"Qualification"}</BlockTitle>
                  <hr />
                  {"Experiences "}
                  {isLoading ? null : formatExperience(qyears, qmonths)}
                  <table className="table table-bordered table-scroll mt-3" id="productTable">
                    <thead>
                      <tr>
                        <th className="w-25" scope="col ">
                          Qualification
                          <Required />
                        </th>
                        <th className="w-25" scope="col ">
                          Sub Qualification
                        </th>
                        {/* <th scope="col ">
                          Degree
                          <Required />
                        </th> */}
                        {/* <th scope="col ">
                          Certificate Number
                          <Required />
                        </th> */}
                        <th scope="col ">
                          University
                          <Required />
                        </th>
                        <th scope="col">
                          Passing Year
                          <Required />
                        </th>
                        {/* <th scope="col">
                          Certificate
                          <Required />
                        </th> */}

                        <th scope="col">
                          {watch("qualificationList")?.length == fields?.length ? null : (
                            <Button
                              type="button"
                              color="primary"
                              outline
                              size={"xs"}
                              className={`  me-n1`}
                              id="addProduct"
                              onClick={() =>
                                append({
                                  degree: "",
                                  passing_year: "",
                                  certificate_no: "",
                                  university: "",
                                  certificate: null,
                                  certificate_url: null,
                                })
                              }
                            >
                              <Icon name="plus"></Icon>
                            </Button>
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {fields.map((field, index) => (
                        <tr key={field.id}>
                          <td>
                            <MySelect
                              register={register}
                              watch={watch}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.qualification`}
                              placeholder="Select Qualification"
                              options={getFilteredQualificationOptions(index)}

                              required
                              titleR="qualification"
                              setValue={(name, value) => {
                                setValue(name, value);
                                getSubqualificationList(value, index);
                                setValue("specialization", null);
                                setValue("specializationDD", []);
                                if (value?.value == 2 && !isQualificationSelected("1")) {
                                  append({
                                    qualification: { value: 1, label: "BAMS" },
                                    passing_year: "",
                                    university: "",
                                  });
                                }
                              }}
                            />
                          </td>

                          <td>
                            <MySelect
                              register={register}
                              watch={watch}
                              setValue={(name, value) => {
                                setValue(name, value);
                                setValue("specialization", null);
                                // setValue("specializationDD", []);
                              }}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.sub_qualifications`}
                              placeholder="Select Sub Qualification"
                              options={watch(`sub_qualificationMap.${index}`) || []}
                              // required
                              titleR="sub_qualificationList"
                              disabled={
                                !watch(`qualifications.${index}.qualification`) ||
                                watch(`qualifications.${index}.qualification`).value == 1
                              } // FIXED
                            />
                          </td>
                          {/* <td>
                            <MyInput
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.degree`}
                              placeholder={"Enter degree"}
                              required
                              min={2}
                              max={50}
                            />
                          </td> */}
                          {/* <td>
                            <MyInput
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.certificate_no`}
                              placeholder={"Enter certificate number"}
                              required
                              min={3}
                              max={50}
                            />
                          </td> */}
                          <td>
                            <MyInput
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.university`}
                              placeholder={"Enter university name"}
                              required
                              min={3}
                              max={50}
                            />
                          </td>
                          <td>
                            <MyDate
                              control={control}
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              name={`qualifications.${index}.passing_year`}
                              placeholder={"Enter year of passing"}
                              required
                              max={moment().subtract(0, "years").toDate()}
                              min={moment().subtract(90, "years").toDate()}
                              disabled={mode == "Approval"}
                              year
                            />
                          </td>
                          {/* <td>
                            <ImageUpload
                              getValues={getValues}
                              approve={mode === "Approval" ? true : false}
                              id={`certificate_image_${index}`}
                              watch={watch}
                              trigger={trigger}
                              setError={setError}
                              clearErrors={clearErrors}
                              errors={errors}
                              register={register}
                              image={`qualifications.${index}.certificate`}
                              image_url={`qualifications.${index}.certificate_url`}
                              setValue={setValue}
                              handleImageOpenPreview={handleImageOpenPreview}
                              required
                              validateDoc
                            />
                          </td> */}
                          <td>
                            {index === 0 ? null : (
                              <Button
                                type="button"
                                color="danger"
                                size="xs"
                                outline
                                onClick={() => remove(index)}
                                disabled={mode == "Approval"}
                              >
                                <Icon name="trash" />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Row>
              <Row>
                <Col md="3" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Specialization"}
                    name={"specialization"}
                    placeholder={"Select specialization"}
                    required
                    options={watch("specializationDD")}
                    multi
                    max={3}
                  />
                </Col>
              </Row>
              <div className="d-flex align-items-center align-content-center">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="experienceToggle"
                  checked={watch("exp")}
                  onChange={(e) => {
                    setValue("exp", e.target.checked);
                    if (!e.target.checked) {
                      removeExperience();
                    }
                  }}
                  disabled={mode == "Approval"}
                  style={{ marginTop: "30px", border: "1px solid #628046" }}
                />
                <label
                  style={{ marginTop: "30px" }}
                  className="form-check-label mx-2 fw-bold "
                  htmlFor="experienceToggle"
                >
                  Have Any Experience
                </label>
              </div>
              <hr />
              {watch("exp") ? (
                <Row>
                  <div className="my-div mt-2 ">
                    <BlockTitle tag="h6">
                      {"Experiences "}
                      {/* {isLoading ? null : formatExperience(yearss, months)} */}
                    </BlockTitle>
                    <hr />
                    <div className="table-responsive-sm">
                      <table className="table table-bordered  mt-3" id="productTable">
                        <thead>
                          <tr>
                            <th scope="col " className="w-25">
                              Organization
                              <Required />
                            </th>
                            <th scope="col " className="w-25">
                              Department
                              <Required />
                            </th>
                            <th scope="col " className="w-25">
                              From Date
                              <Required />
                            </th>
                            <th scope="col" className="w-25">
                              To Date
                              <Required />
                            </th>

                            <th scope="col">
                              <Button
                                type="button"
                                color="primary"
                                outline
                                size={"xs"}
                                className={`  me-n1`}
                                id="addProduct"
                                onClick={() =>
                                  appendExperience({
                                    organization: "",
                                    from_date: null,
                                    to_date: null,
                                    department_id: "",
                                    is_current: false,
                                  })
                                }
                                disabled={mode == "Approval"}
                              >
                                <Icon name="plus"></Icon>
                              </Button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {experienceFields.map((field, index) => (
                            <tr key={field.id}>
                              <td>
                                <MyInput
                                  register={register}
                                  watch={watch}
                                  setValue={setValue}
                                  trigger={trigger}
                                  errors={errors}
                                  name={`experiences.${index}.organization`}
                                  placeholder={"Enter organization name"}
                                  required
                                  min={3}
                                  max={50}
                                  disabled={mode == "Approval"}
                                />
                              </td>
                              <td>
                                <MySelect
                                  register={register}
                                  watch={watch}
                                  setValue={setValue}
                                  trigger={trigger}
                                  errors={errors}
                                  // name={"department"}
                                  // name={`experiences.${index}.department`}
                                  name={`experiences.${index}.department_id`}
                                  placeholder={"Select department"}
                                  required
                                  options={watch("departmentDD")}
                                  disabled={mode == "Approval"}
                                />
                              </td>

                              <td>
                                <MyDate
                                  control={control}
                                  register={register}
                                  watch={watch}
                                  setValue={setValue}
                                  trigger={trigger}
                                  errors={errors}
                                  name={`experiences.${index}.from_date`}
                                  placeholder={"Enter from date"}
                                  required
                                  max={moment().subtract(0, "years").toDate()}
                                  min={moment().subtract(90, "years").toDate()}
                                  disabled={mode == "Approval"}
                                  month
                                />
                              </td>
                              <td>
                                <div className="d-flex">
                                  {" "}
                                  <MyCheck
                                    register={register}
                                    watch={watch}
                                    setValue={setValue}
                                    trigger={trigger}
                                    errors={errors}
                                    name={`experiences.${index}.is_current`}
                                    placeholder={"Current"}
                                  // disabled={mode == "Approval"}
                                  />
                                  {watch(`experiences.${index}.is_current`) == false && (
                                    <MyDate
                                      control={control}
                                      register={register}
                                      watch={watch}
                                      setValue={setValue}
                                      trigger={trigger}
                                      errors={errors}
                                      name={`experiences.${index}.to_date`}
                                      placeholder={"Enter To Date"}
                                      required
                                      max={moment().toDate()}
                                      min={moment().subtract(90, "years").toDate()}
                                      disabled={mode == "Approval"}
                                      month
                                    />
                                  )}
                                </div>
                              </td>

                              <td>
                                {index === 0 ? null : (
                                  <Button
                                    type="button"
                                    color="danger"
                                    size="xs"
                                    outline
                                    onClick={() => removeExperience(index)}
                                    disabled={mode == "Approval"}
                                  >
                                    <Icon name="trash" />
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Row>
              ) : null}
              <Row>
                <div className="d-flex gap-5 mb-4">
                  <Col md="2">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Credit Limit"
                      name="credit"
                      placeholder="Enter Credit Limit"
                      required
                    />
                  </Col>
                  <Col md="2">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Consultation Fees"
                      name="online_consultation_fees"
                      placeholder="Enter consultation fee"
                      required
                    />
                  </Col>{" "}
                  {/* <h5>{"Slot Management & Availability"}</h5> */}
                  {/* <h5>{"Fees"}</h5> */}
                </div>
                {/* <Col md="2">
                  <DateComponent
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Start Time"
                    name="start_time"
                    placeholder="start time"
                    required
                  />
                </Col> */}

                {/* <Col md="2">
                  <DateComponent
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="End Time"
                    name="end_time"
                    placeholder="end time"
                    required
                  />
                </Col> */}

                {/* <Col md="3" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Availability"}
                    name={"show_availability"}
                    placeholder={"Availability"}
                    required
                    options={[
                      { value: "Monthly", label: "Monthly" },
                      { value: "Weekdays", label: "Weekdays" },
                      { value: "Weekends", label: "Weekends" },
                    ]}
                  />
                </Col> */}

                {/* <Col md={2}>
                  <div className="form-group my-2">
                    <label className="form-label fw-semibold">Duration</label>
                    <select
                      {...register("duration",{ required: true })}
                       className="form-select"
                
                    >
                      <option value="">Select Duration</option>
                      {slotDuration.map((s) => (
                        <option key={s.value || s.label} value={s.value || s.label}>
                          {s.label}
                        </option>
                      ))}
                    </select>
                    <div style={{fontStyle:"italic",fontSize:"11px"}} className="text-danger ">{errors.duration && ("Duration is required")}</div>
                  </div>
                </Col> */}
                {/* <Col md="2">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Consultation Fees"
                    name="online_consultation_fees"
                    placeholder="Enter consultation fee"
                    required
                  />
                </Col> */}
              </Row>
              {mode == "Approval" && (
                <Col md="12" className={`mt-3`}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Remark"}
                    name={"remark"}
                    placeholder={"Reason for approval/rejection"}
                    required
                    min={25}
                    max={500}
                    cols={2}
                    row={2}
                  />
                </Col>
              )}
              {(mode == "Add" || mode == "Edit") && (
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              )}

              {mode == "Approval" && (
                <>
                  <Row>
                    <div className="d-flex">
                      <div className="form-group" style={{ marginTop: "31px" }}>
                        <Button
                          color="primary"
                          size="md"
                          type="submit"
                          onClick={() => setValue("actionType", "approve")}
                          disabled={isLoading || watch("objectionKeys")?.length > 0} // Disable if already rejected
                        >
                          {isLoading ? <Spinner size="sm" color="light" /> : "Approve Doctor"}
                        </Button>
                      </div>

                      <div className="form-group mx-2" style={{ marginTop: "31px" }}>
                        <Button
                          disabled={isLoading || watch("objectionKeys")?.length <= 0} // Disable if already rejected
                          color="primary"
                          size="md"
                          type="submit"
                          onClick={() => setValue("actionType", "change_requested")}
                        >
                          {isLoading ? <Spinner size="sm" color="light" /> : "Change Request"}
                        </Button>
                      </div>
                    </div>
                  </Row>
                </>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};
export default DoctorRegistration;
